(function (window, $j) {

    //close Button selector
    var closeNav = $j(".utility-nav").find(".close-x");
    var menu = $j(".utility-nav").find(".toggle");
    var menuItems = $j(".utility-nav,.utility-nav *");
    //Reset form on Closing- remove error styles
    var resetFormOnClose = function () {
        $j(".form-control").each(function () {
            $j(this).removeClass("error");
            $j(this).next("label.error").remove();
        });
    }

    //Utility Navigation on Header
    $j(".utility-nav>ul>li>a[href='#']").bind("click", function (e) {
        e.preventDefault();
        resetFormOnClose();
        if ($j(this).next().hasClass("hidden")) {
            $j(".utility-nav>ul>li").find(".menu").addClass("hidden");
            $j(this).next().removeClass("hidden");
            $j(this).attr("aria-expanded", "true")
        }
        else {
            $j(".utility-nav>ul>li").find(".menu").addClass("hidden");
            $j(this).next().addClass("hidden");
            $j(this).attr("aria-expanded", "false");
        }
    });
    $j(document).on("keydown","#secondary-contact-us,#secondary-check-in,#secondary-myreservation", function(event) {
        var menu = $j(event.target);
        if (event.keyCode === 13 || event.keyCode === 27 || event.keyCode === 40) { // enter || esc || down arrow
             menu.trigger("click");
            event.preventDefault();
        }
    });
    //Close utilitynav on close button
    closeNav.bind("click", function (e) {
        e.preventDefault();
        resetFormOnClose();
        $j(this).closest(".menu").addClass("hidden");
        $j(this).closest("li").find(".toggle").attr("aria-expanded", "false");
    });
    //Close utilitynav after tabbing through
    closeNav.bind("keydown", function(e) {
        if (event.keyCode === 9 || event.keyCode === 27) { // tab || esc
            e.preventDefault();
            resetFormOnClose();
            $j(this).closest(".menu").addClass("hidden");
            $j(this).closest("li").find(".toggle").attr("aria-expanded", "false");
            if (document.activeElement.parentElement.parentElement.firstElementChild.id == "secondary-contact-us") {
                document.getElementById("secondary-check-in").focus()
            }
            if (document.activeElement.parentElement.parentElement.firstElementChild.id == "secondary-check-in") {
                document.getElementById("secondary-myreservation").focus()
            }
            if (document.activeElement.parentElement.parentElement.firstElementChild.id == "secondary-myreservation") {
                document.getElementById("profile-login").focus()
            }
        }
    });
    // Prevent default behavior of anchor tag - Close menu
    $j(".menu-close").bind("click", function (e) {
        e.preventDefault();
    });  
    $j(document).ready(function () {
        var lang = $j("#secondary-language").data("language");
        if (lang === "fr-CA") {
            $j(".utility-nav").addClass("fr-lang");
        }
    });
    //Close utilitynav on escape button
    menuItems.bind("keydown", function(e) {
        if (event.keyCode === 27) { // esc
            e.preventDefault();
            resetFormOnClose();
            $j(this).closest(".menu").addClass("hidden");
            $j(this).closest("li").find(".toggle").attr("aria-expanded", "false");
        }
    });
    //Close utilitynav if click outside modal
    $j(document).click(function(e) {
        if ($j(e.target).is(".utility-nav,.utility-nav *")) {
            return;
        }
            //close form
            resetFormOnClose();
            closeNav.closest(".menu").addClass("hidden");
            closeNav.closest("li").find(".toggle").attr("aria-expanded", "false");
    });

})(window, $j);


